// extracted by mini-css-extract-plugin
export default {"button":"error-overlay_button__KR5AP","show":"error-overlay_show__W+t3m"};